export const Container = ({ children }) => (
  <div className="container">
    {children}
    <style jsx>{`
      .container {
        padding-right: 18px;
        padding-left: 18px;
      }

      @media screen and (min-width: 750px) {
        .container {
          max-width: 1200px;
          margin-right: auto;
          margin-left: auto;
        }
      }
    `}</style>
  </div>
);
